import React, { useState, useEffect } from 'react';
import api from '../utils/api';

const SuperAdminManagement = () => {
  const [superAdmins, setSuperAdmins] = useState([]);

  const fetchSuperAdmins = async () => {
    try {
      const res = await api('/master-admin/super-admins');
      const data = await res.json();
      if (res.ok) {
        setSuperAdmins(data);
      }
    } catch (err) {
      console.error("Error fetching Super Admins:", err);
    }
  };

  useEffect(() => {
    fetchSuperAdmins();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this Super Admin? This cannot be undone.")) {
      try {
        const res = await api(`/master-admin/super-admins/${id}`, {
          method: 'DELETE'
        });
        if (res.ok) {
          fetchSuperAdmins();
        } else {
          const data = await res.json();
          alert("Error deleting Super Admin: " + data.message);
        }
      } catch (err) {
        alert("Error deleting Super Admin: " + err.message);
      }
    }
  };

  return (
    <div>
      <div className="ma-header">
        <h1>Super Admin Management</h1>
      </div>

      <div className="ma-table-container">
        <table className="ma-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Company</th>
              <th>Tenant ID</th>
              <th>Joined</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {superAdmins.length > 0 ? (
              superAdmins.map(admin => (
                <tr key={admin._id}>
                  <td>{admin.name}</td>
                  <td>{admin.email}</td>
                  <td>{admin.phone || 'N/A'}</td>
                  <td>{admin.companyName || 'N/A'}</td>
                  <td><code style={{ color: 'var(--ma-primary)' }}>{admin.tenantId}</code></td>
                  <td>{admin.createdAt ? new Date(admin.createdAt).toLocaleDateString('en-IN') : 'N/A'}</td>
                  <td>
                    <button
                      onClick={() => handleDelete(admin._id)}
                      className="ma-btn-delete"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" style={{ textAlign: 'center', padding: '2rem', color: 'var(--ma-text-muted)' }}>
                  No Super Admins found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SuperAdminManagement;
